import { createSlice,PayloadAction} from '@reduxjs/toolkit';
import {getIndustries,
  getRecommendationSources,
  getQrCode,
  getPDF,
  downloadQR,
  downloadStamp,
  getUserLocation,
  saveSubscription
} from '../api/commonThunk';
import {Industry,CountryData} from '../../utils/interface';

interface recommendationSources{
  id:string;
  relation_name:string;
}

interface AfterMessage{
   isDsiplay:boolean;
   message:string;
   type?:string;
}

interface State {
    data:any;
    country:CountryData | null;
    recommendationSources:any;
    isLoading: boolean;
    error: string | null;

    file_url:string;
    isGenerating:boolean;
    isQRError:boolean;
    
    isStampGenerating:boolean;

    isPDFGenerating:boolean;
    isPDFError:boolean;

    afterMessage:AfterMessage;

  }
  
  const initialState: State = {
    data: null,
    country:null,
    recommendationSources:null,
    isLoading: false,
    error: null,

    file_url:"",
    isGenerating:false,
    isQRError:false,

    isPDFGenerating:false,
    isPDFError:false,

    isStampGenerating:false,

    afterMessage: {
      isDsiplay: false,
      message: "",
      type:"success"
    },
    
    }


  const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
      setAfterMessage(state,action:PayloadAction<AfterMessage>) {
        state.afterMessage.isDsiplay = action.payload.isDsiplay;
         state.afterMessage.type = action.payload.type || "success";
        state.afterMessage.message = action.payload.message;

      },
  
      resetAfterMessage(state) {
        state.afterMessage.isDsiplay =false;
        state.afterMessage.message = "";
        state.afterMessage.type = "success";
      },
    },
    extraReducers: (builder) => {
      builder

        .addCase(getIndustries.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getIndustries.fulfilled, (state, action: PayloadAction<Industry[]>) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(getIndustries.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload as string;
        })


        .addCase(getRecommendationSources.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getRecommendationSources.fulfilled, (state, action: PayloadAction<recommendationSources[]>) => {
          state.isLoading = false;
          state.recommendationSources = action.payload;
        })
        .addCase(getRecommendationSources.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload as string;
        })


        .addCase(getQrCode.pending, (state) => {
          state.isGenerating = true;
        })
        .addCase(getQrCode.fulfilled, (state, action) => {
          state.file_url = action.payload.qr;
          state.isQRError = false;
          state.isGenerating = false;
        })
        .addCase(getQrCode.rejected, (state, action) => {
          state.isGenerating = false;
          state.isQRError=true;
        })


        .addCase(downloadQR.pending, (state) => {
          state.isGenerating = true;
        })
        .addCase(downloadQR.fulfilled, (state, action) => {
          state.isQRError = false;
          state.isGenerating = false;
        })
        .addCase(downloadQR.rejected, (state, action) => {
          state.isGenerating = false;
          state.isQRError=true;
        })


        .addCase(getPDF.pending, (state) => {
          state.isPDFGenerating = true;
        })
        .addCase(getPDF.fulfilled, (state) => {
          state.isPDFError=false;
          state.isPDFGenerating = false;
        })
        .addCase(getPDF.rejected, (state) => {
          state.isPDFGenerating = false;
          state.isPDFError=true;
        })


        .addCase(downloadStamp.pending, (state) => {
          state.isStampGenerating = true;
        })
        .addCase(downloadStamp.fulfilled, (state, action) => {
          state.isStampGenerating = false;
        })
        .addCase(downloadStamp.rejected, (state, action) => {
          state.isStampGenerating = false;
        })


        .addCase(getUserLocation.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getUserLocation.fulfilled, (state, action: PayloadAction<CountryData>) => {
          state.isLoading = false;
          state.country = action.payload;
        })
        .addCase(getUserLocation.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload as string;
        })

        
        .addCase(saveSubscription.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(saveSubscription.fulfilled, (state, action: PayloadAction<any>) => {
          state.isLoading = false;
        })
        .addCase(saveSubscription.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload as string;
        })


    },
  });
  export const {setAfterMessage,resetAfterMessage} = commonSlice.actions;
  export default commonSlice.reducer;